import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ApplyNavbar } from '../../components/apply/ApplyNavbar';

export function ApplySuccessPage() {
  const [searchParams] = useSearchParams();
  const registrationId = searchParams.get('id') || '';

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg,#180f16 0%,#1e1220 34%,#241525 100%)' }}>
      <ApplyNavbar />
      <div className="page-hero lively">
        <div className="container narrow text-center">
          <div className="success-icon">🎉</div>
          <h1>报名成功！</h1>
          <p className="lead">您的报名已提交成功，请保存好您的报名编号。</p>

          {registrationId && (
            <div className="registration-id-card">
              <span className="label">报名编号</span>
              <span className="id">{registrationId}</span>
            </div>
          )}

          <div className="actions">
            <Link to="/apply" className="btn primary">返回首页</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
